// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {DescriptioncourseModuleLayout} from 'app_components/modules/academic/descriptioncourse'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @ADD Component types
interface IDescriptioncourseModuleProps {
  course: ICourse | null
}
interface IDescriptioncourseModuleState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class DescriptioncourseModule extends Component<IDescriptioncourseModuleProps, IDescriptioncourseModuleState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IDescriptioncourseModuleProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  render() {
    return(
      <DescriptioncourseModuleLayout
        course={this.props.course}
      />
    )
  }
}

export default connect(mapStatesToProps)(DescriptioncourseModule)
